
import { Truck, Network, Building2, Bot } from 'lucide-react';

// Headline impact metrics: the scale of the platforms Ravi architects and leads.
export const metricsData = [
    { id: 1, icon: <Truck size={30} />, value: '100K+', label: 'Commercial vehicles served', detail: 'Across the U.S. & Canada' },
    { id: 2, icon: <Network size={30} />, value: '2,000+', label: 'Active enterprise integrations', detail: 'Real-time webhook delivery' },
    { id: 3, icon: <Building2 size={30} />, value: '200+', label: 'Authorized resellers', detail: 'National distribution network' },
    { id: 4, icon: <Bot size={30} />, value: '60%', label: 'Faster support resolution', detail: 'Production RAG AI system' },
];
